"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f232 = void 0;
exports.f232 = {
    "èédzá": [
        3351
    ],
    "èdà": [
        3462
    ],
    "èdè yorùbá": [
        8869,
        8870,
        8871,
        8872
    ],
    "èdè": [
        8869,
        8870,
        8871,
        8872
    ]
};
